import { ANCHORABLE_PLUGIN_NODES, ANCHORABLE_TEXT_NODES } from "./constants";
const isAnchorableNode = (node) => {
  return ANCHORABLE_PLUGIN_NODES.includes(node.type) || ANCHORABLE_TEXT_NODES.includes(node.type);
};
export {
  isAnchorableNode
};
//# sourceMappingURL=is-anchorable-node.js.map
